export default {
  LANDING: "Landing",
}
